import * as Plot from '@observablehq/plot';
import type { Root } from 'react-dom/client';
import { createRoot } from 'react-dom/client';

let tooltipRoot: Root | null = null;
let tooltipContainer: HTMLElement | null = null;

// Needed this to make hover & tooltip work properly for bar charts with multiple facets
export const hoverRectWithTooltip = (
	groups: { group: string | number | Date }[],
	options: {
		hoverOpacity: string;
		isFacet: boolean;
		isHorizontal: boolean;
		tooltipRenderer?: (args: {
			x: number;
			y: number;
			groupIndex: number;
		}) => React.ReactElement;
	}
): Plot.Markish => {
	const handleSvgBar = (
		g: SVGElement,
		context: Plot.Context,
		index: number
	) => {
		g.onmouseenter = () => {
			g.style.fillOpacity = options.hoverOpacity;

			if (tooltipRoot) {
				tooltipRoot.unmount();
				tooltipRoot = null;
			}
			if (tooltipContainer) {
				tooltipContainer.remove();
				tooltipContainer = null;
			}

			// set styles for parent node
			if (
				context.ownerSVGElement &&
				context.ownerSVGElement.parentNode &&
				options.tooltipRenderer
			) {
				// eslint-disable-next-line no-param-reassign
				(context.ownerSVGElement.parentNode as HTMLElement).style.position =
					'relative';

				// const parentBoundingRect = (
				// 	context.ownerSVGElement.parentNode as HTMLElement
				// ).getBoundingClientRect();

				const boundingRect = g.getBoundingClientRect();

				const x = boundingRect.left + boundingRect.width / 2;
				const y = boundingRect.top + boundingRect.height / 2;

				// just a side-effect. this mark doesn't render anything into the SVG
				const reactElement: React.ReactElement | null = options.tooltipRenderer
					? options.tooltipRenderer({
							x,
							y,
							groupIndex: index,
						})
					: null;

				if (reactElement) {
					tooltipContainer = document.createElement('div');
					// tooltipContainer.style.position = 'absolute';
					// // Set style so that it's starts at the same position as g
					// tooltipContainer.style.left = `${boundingRect.left - parentBoundingRect.left + boundingRect.width / 2}px`;
					// tooltipContainer.style.top = `${boundingRect.top - parentBoundingRect.top + boundingRect.height / 2}px`;
					// tooltipContainer.style.pointerEvents = 'none';
					context.ownerSVGElement.parentNode.appendChild(tooltipContainer);
					tooltipRoot = createRoot(tooltipContainer);
					tooltipRoot.render(reactElement);
				}
			}
		};
		g.onmouseleave = () => {
			if (tooltipRoot) {
				tooltipRoot.unmount();
				tooltipRoot = null;
			}
			if (tooltipContainer) {
				tooltipContainer.remove();
				tooltipContainer = null;
			}

			// Set opacity to 0
			g.style.fillOpacity = '0';
		};
	};
	return Plot.rect(groups, {
		// ...options,
		fillOpacity: 0,
		fx: !options.isHorizontal && options.isFacet ? 'group' : undefined,
		fy: options.isHorizontal && options.isFacet ? 'group' : undefined,
		x: !options.isHorizontal && !options.isFacet ? 'group' : undefined,
		y: options.isHorizontal && !options.isFacet ? 'group' : undefined,
		render: (index, scales, values, dimensions, context, next) => {
			if (!next) return null;
			const g = next(index, scales, values, dimensions, context);
			if (!g) return null;

			if (options.isFacet) {
				handleSvgBar(g, context, index[0]);
			} else {
				Array.from(g.children).forEach((child, i) => {
					handleSvgBar(child as SVGElement, context, index[i]);
				});
			}
			return g;
		},
	});
};
